export const appColor = {
  primary: "#0a1d40",
  secondary: "#17314c",
  faded: "#1c3957",
};
